module.exports = __webpack_public_path__ + "assets/bf-fr.8d767809.svg";